"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonViewStyled = void 0;
exports.PersonViewStyled = styled.div.attrs({ className: 'octo' }) `
&.octo {
  display: flex;
  flex-flow: column nowrap;
  gap: 1.5em;
  align-items: stretch;
  justify-content: flex-start;
}
`;
//# sourceMappingURL=PersonView.styled.js.map